module.exports = __webpack_public_path__ + "img/301 건강과과학-전자레인지-카카오톡.fdfb2711.png";